import auth from './auth';
import analytics from './analytics';
import preferences from './preferences';
import accounts from './accounts';
import ui from './ui';
import content from './content';
import progress from './progress';
import profile from './profile';
import questions from './questions';
import role from './role';
import search from './search';
import babies from './babies';
import basicRecords from './basicRecords';
import growthRecords from './growthRecords';
import dietDiaperRecords from './dietDiaperRecords';
import milestoneRecords from './milestoneRecords';
import sleepRecords from './sleepRecords';
import pin from './pin';
import entries from './entries';
import roles from './roles';
import onboarding from './onboarding';
import invites from './invites';
import dischargeProgress from './dischargeProgress';
import moduleIntroPages from './moduleIntroPages';
import dischargeSteps from './dischargeSteps';
import glossary from './glossary';
import subpage from './subpage';
import menu from './menus';
import onboardingContent from './onboardingContent';
import videos from './videos';
import requests from './requests';

export default {
  auth,
  analytics,
  preferences,
  accounts,
  ui,
  content,
  progress,
  profile,
  questions,
  role,
  search,
  babies,
  basicRecords,
  growthRecords,
  dietDiaperRecords,
  milestoneRecords,
  sleepRecords,
  pin,
  entries,
  roles,
  onboarding,
  invites,
  dischargeProgress,
  moduleIntroPages,
  dischargeSteps,
  glossary,
  subpage,
  menu,
  onboardingContent,
  videos,
  requests
};



// WEBPACK FOOTER //
// ./src/reducers/index.js